import styled from 'styled-components';
import theme from '../theme'

export const VerticalMiddle = styled.div`
    display: table-cell;
    vertical-align: middle;    
    height: 100vh;
    width: 100vw;
`

export const BottomMiddle = styled.div`    
    position: absolute;
    text-align: center;
    bottom: 0;
    left: 0;
    right: 0;
`

export const Divider = styled.div`
    height: 0.063rem;
    background-color: ${theme.colors.gray_2}
`